import React from 'react'
import styled from 'styled-components';

function PageInfo({
    homeRender
}) {
    const data = pagesInfo[homeRender];

  return (
    <Container>
        <h1>{data.title}</h1>
        <p>{data.subtitle}</p>
    </Container>
  )
}

const pagesInfo = {
  Dashboard: {
    title: 'Panel de Control',
    subtitle: 'Monitoreo general de consumo energético'
  },
  Mapa: {
    title: 'Mapa de Dispositivos',
    subtitle: 'Visualización geográfica de medidores energéticos'
  },
  Dispositivos: {
    title: 'Gestión de Dispositivos',
    subtitle: 'Monitoreo y control de medidores energéticos'
  }
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;

    h1 {
        margin: 0;
        font-family: 'montserrat', sans-serif;
        font-size: 1.5rem;
    }
    p {
        margin: 0;
        font-family: 'montserrat', sans-serif;
        font-size: 1rem;
    }
`
export default PageInfo